/*
 * sectionsAction.js
 * trt_cms2
 *
 * Created by Hisyam on 16/03/2020, 11:19 AM.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_SECTION_FULFILLED,
  DELETE_SECTION_FULFILLED,
  FETCH_SECTION,
  FETCH_SECTION_FULFILLED,
  RESET_REDIRECT_SECTION,
  UPDATE_SECTION,
  UPDATE_SECTION_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {catchError, debounceTime, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {SECTIONS_API} from "../../config/api";
import {apiHeader} from "../../config/helper";
import {of} from "rxjs";
import {returnErrors} from "../messages/messagesAction";

export const fetchSection = (id) => ({type: FETCH_SECTION, id});
const fetchSectionFulfilled = payload => ({type: FETCH_SECTION_FULFILLED, payload: payload});
export const fetchSectionEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_SECTION),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(SECTIONS_API + `${action.id}/`, apiHeader(state)).pipe(
    map((response) => fetchSectionFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  )),
);

export const updateSection = (id, section) => ({type: UPDATE_SECTION, payload: section, id});
const updateSectionFulfilled = (payload) => ({type: UPDATE_SECTION_FULFILLED, payload: payload});
export const updateSectionEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_SECTION),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.put(SECTIONS_API + `${action.id}/`, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => updateSectionFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const resetRedirectSectionEpic = action$ => action$.pipe(
  ofType(ADD_SECTION_FULFILLED, UPDATE_SECTION_FULFILLED, DELETE_SECTION_FULFILLED),
  mapTo({type: RESET_REDIRECT_SECTION})
);

export const sectionsEpic = [
  fetchSectionEpic,
  updateSectionEpic,
  resetRedirectSectionEpic
];